import { render, staticRenderFns } from "./AuthSidebar.vue?vue&type=template&id=0a59ba6c&scoped=true&"
import script from "./AuthSidebar.vue?vue&type=script&lang=js&"
export * from "./AuthSidebar.vue?vue&type=script&lang=js&"
import style0 from "./AuthSidebar.vue?vue&type=style&index=0&id=0a59ba6c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a59ba6c",
  null
  
)

export default component.exports